import { useTheme } from '@mui/material/styles';

import { Typography, Grid } from '@mui/material';
import Logo from './LogoImage';
const LogoText = () => {
    const theme = useTheme();
    return (
        <Grid container>
            <Grid item sm={12} display="flex" alignItems="center" gap={1}>
                <Logo width="33%" />
                <Grid container display="block">
                    <Grid item>
                        <Typography
                            variant="h6"
                            sx={{ fontFamily: 'URW DIN BOLD', textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                            DIGITAL
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginTop: '-5px' }}>
                        <Typography
                            variant="h3"
                            sx={{ fontFamily: 'URW DIN BOLD', textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                            ROBOT
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginTop: '-5px' }}>
                        <Typography
                            variant="h2"
                            sx={{ fontFamily: 'URW DIN BOLD', textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                            DASH
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LogoText;
